import { useEffect } from "react";

import { WidgetComponentType } from "models/screenshot";

import {
  DASHBOARD_SCREENSHOT_MODE_BODY_CLASS,
  SCREENSHOT_MODE_BODY_CLASS
} from "../constants";
import { useScreenshotContext } from "./useScreenshotContext";

/**
 * Mirrors the active screenshot onto `<body>` as CSS classes so global styles can
 * dim or hide chrome: `screenshot-mode` for any screenshot, plus
 * `dashboard-screenshot-mode` for a whole-dashboard capture. Both are removed when
 * the screenshot ends or the owning component unmounts.
 */
export const useScreenshotModeStyles = () => {
  const { widget } = useScreenshotContext();
  const screenshotActive = !!widget;
  const dashboardScreenshotActive =
    widget?.widgetComponentType === WidgetComponentType.Dashboard;

  useEffect(() => {
    document.body.classList.toggle(SCREENSHOT_MODE_BODY_CLASS, screenshotActive);
    document.body.classList.toggle(
      DASHBOARD_SCREENSHOT_MODE_BODY_CLASS,
      dashboardScreenshotActive
    );

    return () => {
      document.body.classList.remove(
        SCREENSHOT_MODE_BODY_CLASS,
        DASHBOARD_SCREENSHOT_MODE_BODY_CLASS
      );
    };
  }, [screenshotActive, dashboardScreenshotActive]);
};
